import Icon from '../components/Icon.vue'

Icon.register({"heart":{"width":512,"height":512,"paths":[{"d":"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5 236.3 76.2C186.1 24.3 104.5 15.9 49.7 62.6-13.1 116.2-16.4 212.4 39.8 270.5L233.3 470.3C245.8 483.2 266.1 483.2 278.6 470.3L472.1 270.5C528.4 212.4 525.1 116.2 462.3 62.6z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/heart.js